import React from 'react';

const Navbar = () => {
  return (
    <div className="navbar">
      <h1>WhatsApp</h1>
    </div>
  );
};

export default Navbar;
